import type { PropsWithChildren } from "react";

import FullPageLoading from "../components/feedback/FullPageLoading";
import { useAuth } from "../hooks/useAuth";

/**
 * Gates rendering on oauth2-proxy + CAPS authentication.
 * `useAuth` (via `useAuthentication`) triggers the redirect to
 * `/oauth2/start` or CAPS login when unauthenticated — we render nothing
 * while that handoff is in flight to avoid flashing a broken UI.
 */
function RequireAuth({ children }: PropsWithChildren) {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return <FullPageLoading />;
  }
  if (!isAuthenticated) {
    return null;
  }
  return <>{children}</>;
}

export default RequireAuth;
